module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "div-container container",
    class: [{
      'is-fluid': _vm.full === 'true'
    }],
    style: ([{
      paddingTop: (_vm.paddingTop ? _vm.paddingTop : undefined),
      paddingBottom: (_vm.paddingBottom ? _vm.paddingBottom : undefined)
    }])
  }, [_c('div', {
    staticClass: "columns is-gapless is-centered is-vcentered"
  }, [_c('div', {
    staticClass: "column",
    class: [{
      'is-10': _vm.full !== 'true' && !_vm.columnNum
    }, _vm.columnNum]
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-002e395a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DivContainer.vue
// module id = 960
// module chunks = 1